(function () {
  var DRAG_THRESHOLD = 48;
  var enhancedAttribute = 'data-gallery-modal-enhanced';
  var counterEnhancedAttribute = 'data-gallery-counter-enhanced';
  var modalCounterEnhancedAttribute = 'data-gallery-modal-counter-enhanced';
  var navigationEnhancedAttribute = 'data-gallery-navigation-enhanced';
  var globalNavigationEnhancedAttribute = 'data-gallery-global-navigation-enhanced';
  var thumbnailPreloadEnhancedAttribute = 'data-gallery-thumbnail-preload-enhanced';
  var variantPreloadEnhancedAttribute = 'data-gallery-variant-preload-enhanced';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function isVisibleElement(element) {
    if (!element) return false;

    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function getThumbnailSlides(gallery) {
    return toArray(gallery.querySelectorAll('.as-gallery-thumnails-swiper .swiper-wrapper > .swiper-slide'))
      .filter(function (slide) {
        return !slide.classList.contains('swiper-slide-duplicate');
      });
  }

  function getInsideSlides(gallery) {
    var insideSwiper = gallery.querySelector('.as-media-swiper-inside');
    if (!insideSwiper) return [];

    var seenIndexes = {};

    return toArray(insideSwiper.querySelectorAll('.swiper-wrapper > .swiper-slide'))
      .filter(function (slide) {
        var slideIndex = slide.getAttribute('data-swiper-slide-index');

        if (slide.classList.contains('swiper-slide-duplicate')) return false;
        if (slideIndex === null || slideIndex === '') return true;
        if (seenIndexes[slideIndex]) return false;

        seenIndexes[slideIndex] = true;
        return true;
      });
  }

  function getGallerySlides(gallery) {
    var thumbnailSlides = getThumbnailSlides(gallery);

    return thumbnailSlides.length ? thumbnailSlides : getInsideSlides(gallery);
  }

  function warmGalleryImage(image, highPriority) {
    if (!image) return;

    image.setAttribute('loading', 'eager');
    image.setAttribute('decoding', 'async');

    if ('fetchPriority' in image) {
      image.fetchPriority = highPriority ? 'high' : 'low';
    }

    if (image.complete) return;

    var preloadImage = new Image();
    preloadImage.decoding = 'async';

    if ('fetchPriority' in preloadImage) {
      preloadImage.fetchPriority = highPriority ? 'high' : 'low';
    }

    if (image.sizes) preloadImage.sizes = image.sizes;
    if (image.srcset) preloadImage.srcset = image.srcset;
    preloadImage.src = image.currentSrc || image.src;
  }

  function preloadGalleryImage(root, index, highPriority) {
    var slides = getInsideSlides(root);
    if (!slides.length) return;

    var targetSlide = slides[clampIndex(index, slides.length)];
    var image = targetSlide && targetSlide.querySelector('img');

    warmGalleryImage(image, highPriority);
  }

  function preloadGalleryImages(root, force) {
    if (!root || root.__galleryImagesPreloaded) return;
    if (!force && !isVisibleElement(root)) return;

    root.__galleryImagesPreloaded = true;

    getInsideSlides(root).forEach(function (slide, index) {
      window.setTimeout(function () {
        warmGalleryImage(slide.querySelector('img'), index < 2);
      }, index * 60);
    });
  }

  function preloadVisibleProductGalleries() {
    document.querySelectorAll('media-gallery.as-gallery-wrapper').forEach(preloadGalleryImages);
  }

  function activateVariantPreload() {
    var root = document.documentElement;
    if (!root || root.hasAttribute(variantPreloadEnhancedAttribute)) return;
    root.setAttribute(variantPreloadEnhancedAttribute, 'true');

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('.as-product-variant')) return;

      window.setTimeout(preloadVisibleProductGalleries, 120);
    });
  }

  function activateThumbnailPreload(root) {
    if (!root || root.hasAttribute(thumbnailPreloadEnhancedAttribute)) return;
    root.setAttribute(thumbnailPreloadEnhancedAttribute, 'true');

    var preloadFromEvent = function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var thumb = event.target.closest('.as-gallery-thumnails-swiper .swiper-slide, .as-gallery-modal-thumnails-swiper .swiper-slide');
      if (!thumb || !root.contains(thumb)) return;

      var swiper = thumb.closest('.swiper');
      if (!swiper) return;

      var slides = toArray(swiper.querySelectorAll('.swiper-wrapper > .swiper-slide'))
        .filter(function (slide) {
          return !slide.classList.contains('swiper-slide-duplicate');
        });
      var index = slides.indexOf(thumb);

      if (index >= 0) preloadGalleryImage(root, index, true);
    };

    ['pointerover', 'pointerdown', 'touchstart', 'click'].forEach(function (eventName) {
      root.addEventListener(eventName, preloadFromEvent, { passive: true });
    });
  }

  function getActiveThumbnailIndex(gallery) {
    var thumbnailSlides = getThumbnailSlides(gallery);

    for (var index = 0; index < thumbnailSlides.length; index += 1) {
      if (
        thumbnailSlides[index].classList.contains('swiper-gallery-thumb-active') ||
        thumbnailSlides[index].classList.contains('swiper-slide-thumb-active')
      ) {
        return index;
      }
    }

    return -1;
  }

  function getActiveInsideIndex(gallery) {
    var activeSlide = gallery.querySelector('.as-media-swiper-inside .swiper-slide-active');
    if (!activeSlide) return -1;

    var slideIndex = activeSlide.getAttribute('data-swiper-slide-index');
    if (slideIndex !== null && slideIndex !== '') {
      var parsedIndex = parseInt(slideIndex, 10);
      if (!isNaN(parsedIndex)) return parsedIndex;
    }

    return getInsideSlides(gallery).indexOf(activeSlide);
  }

  function getTriggerIndex(gallery) {
    var trigger = gallery.querySelector('.as-modal-trigger[data-current-index]');
    if (!trigger) return -1;

    var triggerIndex = parseInt(trigger.getAttribute('data-current-index'), 10);

    return isNaN(triggerIndex) ? -1 : triggerIndex;
  }

  function clampIndex(index, total) {
    if (index < 0) return 0;
    if (index >= total) return total - 1;

    return index;
  }

  function getRealSlideTotal(swiperEl) {
    if (!swiperEl) return 0;

    var wrapper = swiperEl.querySelector('.as-swiper-wrapper[data-swiper-number]');
    var wrapperTotal = wrapper ? parseInt(wrapper.getAttribute('data-swiper-number'), 10) : 0;

    if (!isNaN(wrapperTotal) && wrapperTotal > 0) return wrapperTotal;

    return toArray(swiperEl.querySelectorAll('.swiper-wrapper > .swiper-slide'))
      .filter(function (slide) {
        return !slide.classList.contains('swiper-slide-duplicate');
      }).length;
  }

  function slideSwiperCircular(control) {
    var swiperEl = control.closest('.media-swiper-inside');
    var swiper = swiperEl && swiperEl.swiper;
    var total = getRealSlideTotal(swiperEl);

    if (!swiper || total < 2) return false;
    if (swiper.animating) return true;

    var currentIndex = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
    var direction = control.classList.contains('as-inside-next') ? 1 : -1;
    var targetIndex = (currentIndex + direction + total) % total;

    if (typeof swiper.slideToLoop === 'function') {
      swiper.slideToLoop(targetIndex);
    } else if (typeof swiper.slideTo === 'function') {
      swiper.slideTo(targetIndex);
    }

    return true;
  }

  function updateProductGalleryCounter(gallery) {
    var counter = gallery.querySelector('.as-inside-pagination.inside-swiper-pagination');
    if (!counter) return;

    var total = getGallerySlides(gallery).length;
    if (total < 2) {
      counter.classList.remove('as-gallery-image-counter');
      counter.removeAttribute('aria-label');
      return;
    }

    var activeIndex = getActiveThumbnailIndex(gallery);
    if (activeIndex < 0) activeIndex = getTriggerIndex(gallery);
    if (activeIndex < 0) activeIndex = getActiveInsideIndex(gallery);

    var label = (clampIndex(activeIndex, total) + 1) + ' / ' + total;

    counter.classList.add('as-gallery-image-counter');
    counter.setAttribute('aria-label', label);

    if (counter.textContent.trim() !== label) {
      counter.textContent = label;
    }
  }

  function scheduleProductGalleryCounter(gallery) {
    if (gallery.__galleryCounterUpdate) return;

    gallery.__galleryCounterUpdate = true;

    var requestUpdate = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 16);
    };

    requestUpdate(function () {
      gallery.__galleryCounterUpdate = false;
      updateProductGalleryCounter(gallery);
    });
  }

  function activateProductGalleryCounter(gallery) {
    if (!gallery || gallery.hasAttribute(counterEnhancedAttribute)) return;
    gallery.setAttribute(counterEnhancedAttribute, 'true');

    var updateCounter = function () {
      scheduleProductGalleryCounter(gallery);
    };

    ['click', 'pointerup', 'touchend', 'transitionend'].forEach(function (eventName) {
      gallery.addEventListener(eventName, updateCounter);
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(updateCounter);
      observer.observe(gallery, {
        attributes: true,
        attributeFilter: ['class', 'data-current-index'],
        subtree: true
      });
    }

    updateCounter();
    window.setTimeout(updateCounter, 300);
    window.setTimeout(updateCounter, 1000);
  }

  function getModalTotal(modal) {
    var wrapper = modal.querySelector('.as-swiper-wrapper[data-swiper-number]');
    var total = wrapper ? parseInt(wrapper.getAttribute('data-swiper-number'), 10) : 0;

    if (!isNaN(total) && total > 0) return total;

    return getInsideSlides(modal).length;
  }

  function getModalActiveIndex(modal) {
    var insideSwiper = modal.querySelector('.as-media-swiper-inside');
    var datasetIndex = parseInt(modal.getAttribute('data-current-index'), 10);

    if (insideSwiper && insideSwiper.swiper && typeof insideSwiper.swiper.realIndex === 'number') {
      return insideSwiper.swiper.realIndex;
    }
    if (!isNaN(datasetIndex)) return datasetIndex;

    return getActiveInsideIndex(modal);
  }

  function updateGalleryModalCounter(modal) {
    var counter = modal.querySelector('.as-inside-pagination.inside-swiper-pagination');
    if (!counter) return;

    var total = getModalTotal(modal);
    if (total < 2) {
      counter.classList.remove('as-gallery-modal-counter');
      counter.removeAttribute('aria-label');
      return;
    }

    var label = (clampIndex(getModalActiveIndex(modal), total) + 1) + ' / ' + total;

    counter.classList.add('as-gallery-modal-counter');
    counter.setAttribute('aria-label', label);

    if (counter.textContent.trim() !== label) {
      counter.textContent = label;
    }
  }

  function scheduleGalleryModalCounter(modal) {
    if (modal.__galleryModalCounterUpdate) return;

    modal.__galleryModalCounterUpdate = true;

    var requestUpdate = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 16);
    };

    requestUpdate(function () {
      modal.__galleryModalCounterUpdate = false;
      updateGalleryModalCounter(modal);
    });
  }

  function activateGalleryModalCounter(modal) {
    if (!modal || modal.hasAttribute(modalCounterEnhancedAttribute)) return;
    modal.setAttribute(modalCounterEnhancedAttribute, 'true');

    var updateCounter = function () {
      scheduleGalleryModalCounter(modal);
    };

    ['click', 'pointerup', 'touchend', 'transitionend'].forEach(function (eventName) {
      modal.addEventListener(eventName, updateCounter);
    });

    if (window.MutationObserver) {
      var observer = new MutationObserver(updateCounter);
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['class', 'data-current-index'],
        subtree: true
      });
    }

    updateCounter();
  }

  function activateGalleryNavigation(root) {
    if (!root || root.hasAttribute(navigationEnhancedAttribute)) return;
    root.setAttribute(navigationEnhancedAttribute, 'true');

    root.addEventListener('click', function (event) {
      var control = event.target.closest && event.target.closest('.media-swiper-inside > .as-inside-prev, .media-swiper-inside > .as-inside-next');

      if (!control || !root.contains(control)) return;

      event.preventDefault();
      event.stopPropagation();

      slideSwiperCircular(control);
    }, true);
  }

  function activateGlobalGalleryNavigation() {
    var root = document.documentElement;
    if (!root || root.hasAttribute(globalNavigationEnhancedAttribute)) return;
    root.setAttribute(globalNavigationEnhancedAttribute, 'true');

    document.addEventListener('click', function (event) {
      var control = event.target.closest && event.target.closest([
        'media-gallery.as-gallery-wrapper .media-swiper-inside > .as-inside-prev',
        'media-gallery.as-gallery-wrapper .media-swiper-inside > .as-inside-next',
        '.gallery-modal .media-swiper-inside > .as-inside-prev',
        '.gallery-modal .media-swiper-inside > .as-inside-next'
      ].join(','));

      if (!control) return;

      event.preventDefault();
      event.stopPropagation();

      slideSwiperCircular(control);
    }, true);
  }

  function isInteractiveTarget(target) {
    if (!target || typeof target.closest !== 'function') return false;

    return Boolean(target.closest([
      '.modal-close-btn',
      '.swiper-button-prev',
      '.swiper-button-next',
      '.inside-swiper-pagination',
      '.thumbnail-swiper',
      'button',
      'a',
      'img',
      'picture',
      'figure',
      'video',
      'iframe',
      'model-viewer',
      'product-model'
    ].join(',')));
  }

  function closeModal(modal) {
    var closeButton = modal.querySelector('.modal-close-btn');
    if (closeButton) closeButton.click();
  }

  function activateModal(modal) {
    if (!modal || modal.hasAttribute(enhancedAttribute)) return;
    modal.setAttribute(enhancedAttribute, 'true');

    var surface = modal.querySelector('.media-swiper-inside');
    if (!surface) return;

    var startX = 0;
    var startY = 0;
    var pointerId = null;

    surface.addEventListener('pointerdown', function (event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.target.closest && event.target.closest('.modal-close-btn, .swiper-button-prev, .swiper-button-next, .inside-swiper-pagination, .thumbnail-swiper')) return;

      startX = event.clientX;
      startY = event.clientY;
      pointerId = event.pointerId;

      if (surface.setPointerCapture) {
        try {
          surface.setPointerCapture(pointerId);
        } catch (error) {}
      }
    });

    surface.addEventListener('pointerup', function (event) {
      if (pointerId !== event.pointerId) return;

      var deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;
      pointerId = null;

      if (surface.releasePointerCapture) {
        try {
          surface.releasePointerCapture(event.pointerId);
        } catch (error) {}
      }

      if (Math.abs(deltaX) <= DRAG_THRESHOLD || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;

      modal.setAttribute('data-gallery-modal-dragging', 'true');
      window.setTimeout(function () {
        modal.removeAttribute('data-gallery-modal-dragging');
      }, 120);

      var control = modal.querySelector(deltaX < 0 ? '.as-inside-next' : '.as-inside-prev');
      if (control) control.click();

      event.preventDefault();
      event.stopPropagation();
    });

    surface.addEventListener('pointercancel', function () {
      pointerId = null;
    });

    modal.addEventListener('click', function (event) {
      if (modal.hasAttribute('data-gallery-modal-dragging')) return;
      if (isInteractiveTarget(event.target)) return;
      if (!event.target.closest('.modal-body, .modal-content, .media-swiper-inside')) return;

      closeModal(modal);
    });
  }

  function activateAll() {
    activateGlobalGalleryNavigation();
    activateVariantPreload();
    document.querySelectorAll('media-gallery.as-gallery-wrapper').forEach(activateProductGalleryCounter);
    document.querySelectorAll('media-gallery.as-gallery-wrapper').forEach(activateGalleryNavigation);
    document.querySelectorAll('media-gallery.as-gallery-wrapper').forEach(activateThumbnailPreload);
    document.querySelectorAll('.gallery-modal').forEach(activateGalleryModalCounter);
    document.querySelectorAll('.gallery-modal').forEach(activateModal);
    document.querySelectorAll('.gallery-modal').forEach(activateGalleryNavigation);
    document.querySelectorAll('.gallery-modal').forEach(activateThumbnailPreload);
    window.setTimeout(preloadVisibleProductGalleries, 300);
  }

  document.addEventListener('DOMContentLoaded', activateAll);
  document.addEventListener('shopify:section:load', activateAll);
  document.addEventListener('show.bs.modal', function (event) {
    if (event.target && event.target.matches('.gallery-modal')) {
      window.setTimeout(function () {
        activateModal(event.target);
        activateGalleryModalCounter(event.target);
        activateGalleryNavigation(event.target);
        activateThumbnailPreload(event.target);
        preloadGalleryImages(event.target, true);
        scheduleGalleryModalCounter(event.target);
      }, 0);
      window.setTimeout(function () {
        scheduleGalleryModalCounter(event.target);
      }, 300);
      window.setTimeout(function () {
        scheduleGalleryModalCounter(event.target);
      }, 1000);
    }
  });
})();
